import React from 'react';
import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import { StaggerCss } from '@mentimeter/question-modules-shared';
import { Box } from '@mentimeter/ragnar-ui/box';
import { useRagnar } from '@mentimeter/ragnar-react';
import { ImageProgressive } from '@mentimeter/ragnar-ui/image-progressive';
import { Label } from '@mentimeter/slides-presentation-ui/title/label';
import { MarkdownText } from '@mentimeter/slides-presentation-ui/text/markdown-text';
import { ResizableTitle } from '@mentimeter/slides-presentation-ui/text/resizable-title';
import { DEFAULT_FONT_OFFSET_TO_TITLE_HEIGHT } from '@mentimeter/slides-presentation-ui/text/resizable-title/font-offset-to-title-size';
import { PlaceholderImage } from './PlaceholderImage';

export function ImagePresentation() {
  const { useQuestion, useConfig } = usePresentationContext();
  const {
    theme: {
      visualizationColors: { titleColor },
    },
  } = useRagnar();

  const {
    question,
    cropped_image_url,
    title_meta,
    slide_image_type,
    image_alt_description,
  } = useQuestion();
  const { enableAnimations } = useConfig();

  return (
    <Box
      width="100%"
      flex={1}
      data-testid="image-container"
      alignItems="center"
      justifyContent="center"
    >
      <StaggerCss index={1} type="fade" enableAnimations={enableAnimations}>
        <Box
          flex="1 1 auto"
          width="100%"
          alignItems="center"
          justifyContent="center"
          mb={question || title_meta ? 3 : 0}
        >
          <Box height="100%" width="100%" position="absolute" top={0} left={0}>
            {slide_image_type === 'image-frame' &&
              (cropped_image_url ? (
                <ImageProgressive
                  src={cropped_image_url}
                  alt={image_alt_description || question}
                  stretch
                />
              ) : (
                <PlaceholderImage />
              ))}
          </Box>
        </Box>
      </StaggerCss>
      <Box width="100%" alignItems="center" py="space1" pl="space2">
        {title_meta && (
          <Label mb="space4">
            <MarkdownText
              disableLineBreaks
              source={title_meta}
              allowHyperlinks
            />
          </Label>
        )}
        {question && (
          <ResizableTitle
            titleText={question}
            height={DEFAULT_FONT_OFFSET_TO_TITLE_HEIGHT[0]}
            shouldAnimate={enableAnimations}
            color={titleColor}
            textAlign="center"
            lineHeight="heading"
            nonInteractiveTitleComponent={
              <MarkdownText
                disableLineBreaks
                allowHyperlinks
                source={question}
              />
            }
            interactiveTitleComponent={null}
          />
        )}
      </Box>
    </Box>
  );
}
